import Vue from 'vue'
import './plugins/vuetify'
import App from './app/index'
import axios from 'axios'
import { Model } from 'vue-api-query'
import { SnackbarModalUtils } from './mixins/reusable_mixins'
import { beforeRequest, errorRequest } from '@/services/InterceptorAxios'

// Format axios (check if user already authenticated)
axios.defaults.headers.common['Content-Type'] = 'application/json'
const token = localStorage.getItem('user-token')
if (token) {
    axios.defaults.headers.common['Authorization'] = token
}

// Add a request and response interceptor
axios.interceptors.request.use(beforeRequest, undefined)
axios.interceptors.response.use(undefined, errorRequest)

import { permissions } from './mixins/reusable_mixins'
Vue.mixin(permissions)

// Linked axios with app models
Model.$http = axios
Vue.use(axios)
Vue.mixin(SnackbarModalUtils)
Vue.config.productionTip = false

import VueBarcodeScanner from 'vue-barcode-scanner'
Vue.use(VueBarcodeScanner)

import colors from '@/mixins/Colors'
import router from './routes/router'
import store from './store/store'
Vue.mixin({
    data: function() {
        return {
            colors: colors,
        }
    },
})

import DevTools from '@/mixins/DevTools'
Vue.mixin(DevTools)

import toolbarButtons from './mixins/reusable_mixins/toolbarButtons'
Vue.mixin(toolbarButtons)

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
